/** 同步记录真实 DialogPlus 占用，覆盖 push / replace / lazy push。 */
let visible = false;
export const DIALOG_VISIBILITY_CHANGED = "dialog-plus-visibility-changed";
export const isDialogPlusVisible = () => visible;
export const setDialogPlusVisible = (next: boolean) => {
  if (visible === next) return;
  visible = next;
  window.dispatchEvent(new Event(DIALOG_VISIBILITY_CHANGED));
};
